import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function Login() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 pb-20 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
        <div className="w-full max-w-lg text-center">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-10 space-y-6">
            <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-accent-100">
              <i className="ri-community-line text-3xl text-accent-600" />
            </div>
            <div>
              <h1 className="font-heading text-3xl font-bold mb-2 text-primary-500">Sign In to ClearMind Club</h1>
              <p className="text-foreground-600 font-body leading-relaxed">
                ClearMind Club gives you access to daily tips, mind training exercises, nootropic breakdowns and member discussions. Our private community space is launching soon.
              </p>
            </div>

            <div className="bg-background-100/70 rounded-xl p-5 text-left space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body">Full access to all articles, routines, and tools</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body">Connect with like-minded members in the community</p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-accent-500 text-lg mt-0.5 shrink-0" />
                <p className="text-sm text-foreground-700 font-body">£9.99/month — cancel anytime</p>
              </div>
            </div>

            <Link
              to="/community"
              className="w-full inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 disabled:pointer-events-none disabled:opacity-50 bg-accent-500 text-foreground-950 hover:bg-accent-700 h-12 rounded-lg text-base px-8"
            >
              Explore the Community
              <i className="ri-arrow-right-line" />
            </Link>

            <p className="text-xs text-foreground-500 font-body">
              Our community is launching soon — check back shortly.
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}